import { render, staticRenderFns } from "./ReturnTo.vue?vue&type=template&id=cbacc356&scoped=true"
import script from "./ReturnTo.vue?vue&type=script&lang=js"
export * from "./ReturnTo.vue?vue&type=script&lang=js"
import style0 from "./ReturnTo.vue?vue&type=style&index=0&id=cbacc356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbacc356",
  null
  
)

export default component.exports